import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./Features/api/apiSlice";
import aiChatReducer from "./Features/states/ai-agent/aiChatSlice";
import authReducer from "./Features/states/auth-management/authSlice";
import v2PermissionsReducer from "./Features/states/auth-management/v2PermissionsSlice";
import floorManagementReducer from "./Features/states/floor-management/floorManagementSlice";
import helpReducer from "./Features/states/help/helpSlice";
import menuReducer from "./Features/states/menu/menuSlice";
import ordersReducer from "./Features/states/orders/ordersSlice";
import reservationReducer from "./Features/states/reservation/reservationSlice";
import companySettingsReducer from "./Features/states/settings/companySettingsSlice";
import stockReducer from "./Features/states/stock/stockSlice";
import teamReducer from "./Features/states/team/teamSlice";
import wasteLogsReducer from "./Features/states/waste-logs/wasteLogsSlice";

export const store = configureStore({
  reducer: {
    aiChat: aiChatReducer,
    auth: authReducer,
    v2Permissions: v2PermissionsReducer,
    companySettings: companySettingsReducer,
    // Feature slices — both branches added one; keep them registered together
    floorManagement: floorManagementReducer,
    help: helpReducer,
    menu: menuReducer,
    orders: ordersReducer,
    reservation: reservationReducer,
    stock: stockReducer,
    team: teamReducer,
    wasteLogs: wasteLogsReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
